import {
    apiRequest,
    flexytimeList,
    flexytimeActive,
    flexytimeInactive
} from "../../../../../services/adapters/kepegawaian/flexytimeService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", flexytimeList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", flexytimeInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", flexytimeActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository